// extracted by mini-css-extract-plugin
export default {"stpes-infom-wrap":"StepsRecordList_stpes-infom-wrap__9APSj","stpes-infom-box":"StepsRecordList_stpes-infom-box__BqehP","inner-box":"StepsRecordList_inner-box__CpthO"};